// extracted by mini-css-extract-plugin
export default {"offer--exit-active":"youroffersko3Pmy","offer--exited":"youroffers5FCl4S"};